export function getVideoDuration(url) {

    return new Promise((reslove) => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.onloadedmetadata = () => {
            reslove(parseInt((video.duration * 1000).toString(), 10));
            video = null;
        };
    });
}

export function getVideoCover(elementVideo, elementCanvas, url) {
    return new Promise((resolve) => {
        let video = elementVideo; // 获取视频对象
        // const video = document.createElement("video") // 也可以自己创建video
        // console.log('----- getVideoCover ' + video)
        video.src = url; // url地址 url跟 视频流是一样的
        var canvas = elementCanvas; // 获取 canvas 对象
        const ctx = canvas.getContext("2d"); // 绘制2d
        video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 1; // 第一帧
        video.oncanplay = () => {
            canvas.width = video.clientWidth; // 获取视频宽度
            canvas.height = video.clientHeight; //获取视频高度
            // 利用canvas对象方法绘图
            ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
            // 转换成base64形式
            let videoCover = canvas.toDataURL("image/png"); // 截取后的视频封面
            resolve(videoCover);
            // video = null;
            // console.log("getVideoCover " + videoCover)
        };
    });

}